import React, { useEffect } from 'react';
import { FiCheckCircle } from 'react-icons/fi';

const SuccessModal = ({ message, onClose, title = 'Success' }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 2200);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 px-4 py-6 backdrop-blur-sm">
      <div className="relative w-full max-w-lg overflow-hidden rounded-[32px] border border-white/10 bg-white/95 p-6 shadow-2xl shadow-slate-900/20">
        <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-emerald-500 via-lime-400 to-cyan-400" />
        <div className="relative pt-6 text-center">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-600 shadow-lg shadow-emerald-500/20">
            <FiCheckCircle className="h-11 w-11" />
          </div>
          <h3 className="mt-5 text-3xl font-semibold text-slate-900">{title}</h3>
          <p className="mx-auto mt-3 max-w-xs text-sm leading-7 text-slate-600">{message}</p>
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-full bg-emerald-600 px-6 py-3 text-sm font-semibold text-white shadow-xl shadow-emerald-600/20 transition hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
